/*
* jqueryのAndApp Dashbord用の拡張
*/
require('./jquery_dashbord/ajax_wrapper')
require('./jquery_dashbord/view_manager')
require('./jquery_dashbord/scroll_nav_controller')
require('./jquery_dashbord/testing_ajax')
